<script>
import substanceDictionaries from "@core/mixins/substance-dictionaries";
import TreeSelect from "@core/components/common/TreeSelect.vue";
import { BFormGroup } from 'bootstrap-vue'

export default {
    components: {TreeSelect, BFormGroup},
    mixins: [substanceDictionaries],
    props: {
        selected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            value: this.selected.map(item => item.property)
        }
    },
    methods: {
        onChange(value) {
            this.value = value;
            this.$emit('input', value);
        },
    },
    created() {
        this.initSubstanceDictionaries();
    },
    watch: {
        selected() {
            this.value = this.selected.map(item => item.property);
        }
    }
}
</script>

<template>
    <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
        <TreeSelect
            :options="mixtureCategories"
            :title="$t('Component(CompositionSubstance):hover-mixture-category')"
            :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
            :value="value"
            @input="onChange"
        />
    </b-form-group>
</template>
